<template>
    <div class="modal fade text-left" id="newExamModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="newExam">{{ $t("models.exam") }} </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form class="form">
                      <exam-form :exam="exam" :exam-types="examTypes" v-bind:typeId.sync="typeId" ref="examForm"/>
                       <div class="form-actions">
                        <button type="button" class="btn btn-success" @click.prevent="createExam($refs.examForm.clonedExam)">
                          <i class="icon-note"></i>
                          {{ this.$t("labels.save") }}
                        </button>
                     </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeNewExamModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MedicalExamsService from '@/services/medicalExams'
import LovService from '@/services/lov'
import moment from 'moment'
import Progress from './Progress'
import ExamForm from '@/components/patient/ExamForm.vue'

export default {
    props: ["patient"],
    components: {
        Progress,
        ExamForm
    },
    data() {
        return {
            errors: [],
            typeId: '',
            examTypes: [],
            exam: {
                date: moment(new Date()).format('YYYY-MM-DD'),
                notes: '',
                document: {},
                patientId: ''
            }
        }
    },
    computed: {
        examType() {
            let result = this.examTypes.find(t => t._id === this.typeId)
            let tpval = {
                id: result._id,
                type: result.type,
                name: result.name
            }
            return tpval
        }
    },
    methods: {
        createExam: async function(exam) {
            this.errors = []
            let loader = this.$loading.show({
                color: '#ccc',
                loader: 'spinner'
            },{
                after: this.$createElement('Progress')
            })
            if (!exam.date) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.examDate")]))
            }
            if (!this.typeId || this.typeId.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.examType")]))
            }
            if (exam.document && exam.document.type) {
                if (!this.$store.state.allowedFileTypes.includes(exam.document.type)) {
                    this.errors.push(this.$t("errors.wrongFiletype", [exam.document.name]))
                }
                let fileSizeMb = exam.document.size/1024/1024
                if (fileSizeMb > 15) {
                    this.errors.push(this.$t("errors.tooLarge", [exam.document.name]))
                }
            }
            if (this.errors.length === 0) {
                exam.type = this.examType
                let formData = new FormData()
                formData.append('document', exam.document)
                formData.append('exam', JSON.stringify(exam))
                let result = await MedicalExamsService.create(formData)
                if (result.data.success) {
                    this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.exam")]))
                    this.exam = {
                        document: {},
                        patientId: this.patient._id
                    }
                    this.$emit('updateexams')
                    this.$emit('updateexamslist')
                    this.$refs.closeNewExamModal.click()
                } else {
                    this.$miniToastr.error(this.$t("flash.createFailed", [this.$t("models.exam")]))
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
            loader.hide()
            this.$store.state.currentProgress = 0
        },
        formatDate(d) {
            return moment(new Date(d)).format("YYYY-MM-DD")
        },
    },
    mounted: async function() {
        let examTypes = await LovService.all('medical_exams', false)
        if (examTypes) {
            this.examTypes = examTypes.data
        }
        this.exam.patientId = this.patient._id
    }
}
</script>